import React, { useState, useEffect } from 'react';
import { Typography, Box, Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import StopperComponent from '../components/Stopper/StopperDeveloper';
import PersonalIdentty from '../components/Identify/PersonalIdentty';
import LegalIdentty from '../components/Identify/LegalIdentty';
import Contract from '../components/Identify/Contract';
import PendingStatus from '../components/StatusBox/PendingStatus';
import WithOutStoper from '../components/Stopper/WithOutStoper';
import { useNavigate, useLocation } from 'react-router-dom';
import { decrementStep } from '../Slice/unifiedFormSlice';

const Identify: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const idedntty = location.state?.idedntty || 'personal';
  const mode = location.state?.mode || 'start';
  const currentStep = useSelector(
    (state: RootState) => state.unifiedForm.currentStep,
  );

  const [internalStep, setInternalStep] = useState<
    'identify' | 'contract' | 'pending'
  >('identify');
  const [userData, setUserData] = useState<{
    id: string;
    display_name: string;
  } | null>(null);

  console.log(
    'Identify - Current Step:',
    currentStep,
    'Mode:',
    mode,
    'Identity:',
    idedntty,
  );

  const handleNextStep = () => {
    setInternalStep('contract');
  };

  const handleSubmitContract = (data: { id: string; display_name: string }) => {
    setUserData(data);
    setInternalStep('pending');
  };

  const handlePreviousStep = () => {
    setInternalStep('identify');
  };

  const handleBack = () => {
    dispatch(decrementStep()); // کاهش currentStep به 2
    navigate('/intro', { state: { mode: 'start' } });
  };

  useEffect(() => {
    if (internalStep === 'pending' && userData) {
      const publishers = [
        { id: userData.id, display_name: userData.display_name },
      ];
      navigate('/wizard', { state: { publishers, mode: 'end' } });
    }
  }, [internalStep, userData, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      {mode === 'start' ? (
        <Typography variant="body1" sx={{ paddingBottom: 4 }}>
          <StopperComponent activeStep={currentStep} />
        </Typography>
      ) : (
        <Typography variant="body1" sx={{ padding: 16 }}>
          <WithOutStoper contentMessage="ایجاد هویت جدید" />
        </Typography>
      )}

      <Button
        variant="outlined"
        onClick={handleBack}
        sx={{ mb: 2, color: '#1E88E5', borderColor: '#1E88E5' }}
      >
        بازگشت
      </Button>

      {internalStep === 'identify' ? (
        <Typography variant="body1">
          {idedntty === 'personal' ? (
            <PersonalIdentty onNext={handleNextStep} />
          ) : idedntty === 'legal' ? (
            <LegalIdentty onNext={handleNextStep} />
          ) : (
            <>نوع هویت نامعتبر</>
          )}
        </Typography>
      ) : internalStep === 'contract' ? (
        <Contract
          onPrevious={handlePreviousStep}
          // onSubmit={handleSubmitContract}
          idedntty={idedntty}
        />
      ) : (
        userData && (
          <PendingStatus
            id={userData.id}
            display_name={userData.display_name}
          />
        )
      )}
    </Box>
  );
};

export default Identify;
